module.exports = __webpack_public_path__ + "vue/img/ebc-logo.52224be8.svg";